import styled from 'styled-components'
import { ContainerStyle } from '@styles'

export const Message = styled.div<{ isMobile: boolean }>`
  text-align: center;
  ${(props) => props.isMobile && ContainerStyle}
`
